export function useWizardTelemetry() {
  const trackEvent = (event: string, payload?: any) => {
    // Future: integrate with analytics service
  };

  return { trackEvent };
}
